var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetting2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/setting-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "setting-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.75 7.68336C15.2417 7.68336 14.625 6.6167 15.375 5.30836C15.8083 4.55003 15.55 3.58336 14.7917 3.15003L13.35 2.32503C12.6917 1.93336 11.8417 2.1667 11.45 2.82503L11.3583 2.98336C10.6083 4.2917 9.375 4.2917 8.61667 2.98336L8.525 2.82503C8.15 2.1667 7.3 1.93336 6.64167 2.32503L5.2 3.15003C4.44167 3.58336 4.18333 4.55836 4.61667 5.3167C5.375 6.6167 4.75833 7.68336 3.25 7.68336C2.38333 7.68336 1.66667 8.3917 1.66667 9.2667V10.7334C1.66667 11.6 2.375 12.3167 3.25 12.3167C4.75833 12.3167 5.375 13.3834 4.61667 14.6917C4.18333 15.45 4.44167 16.4167 5.2 16.85L6.64167 17.675C7.3 18.0667 8.15 17.8334 8.54167 17.175L8.63333 17.0167C9.38333 15.7084 10.6167 15.7084 11.375 17.0167L11.4667 17.175C11.8583 17.8334 12.7083 18.0667 13.3667 17.675L14.8083 16.85C15.5667 16.4167 15.825 15.4417 15.3917 14.6917C14.6333 13.3834 15.25 12.3167 16.7583 12.3167C17.625 12.3167 18.3417 11.6084 18.3417 10.7334V9.2667C18.3333 8.40003 17.625 7.68336 16.75 7.68336ZM10 12.7084C8.50833 12.7084 7.29167 11.4917 7.29167 10C7.29167 8.50836 8.50833 7.2917 10 7.2917C11.4917 7.2917 12.7083 8.50836 12.7083 10C12.7083 11.4917 11.4917 12.7084 10 12.7084Z",
    fill: "#6933FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting2);
export default __webpack_public_path__ + "static/media/setting-2.7d50343b63e2ad65a4769af5f4416ded.svg";
export { ForwardRef as ReactComponent };